export default __webpack_public_path__ + "static/media/write.e08d18a6.svg";